import { HttpContextToken, HttpRequest } from '@angular/common/http';

export const CacheInterceptorContext = new HttpContextToken(() => true);

export const isCacheInterceptorContext = <Body>(
  request: HttpRequest<Body>,
): boolean => {
  return request.context.has(CacheInterceptorContext);
};
